import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// import uuid from 'uuid';


class ToggleButtonField extends PureComponent {
  state = {
    checked: false
  }

  componentDidMount () {
    this.props.onChange(this.props.defaultChecked);
    this.setState({ checked: this.props.defaultChecked })
  }

  handleChange = (event) => {
    this.setState({ checked: !this.state.checked }, () => {
      this.props.onChange(!this.props.checked)
      this.props.saveChange(this.props._key, this.state.checked)
    });
  }

  render () {
    const disabled = this.props.disabled;
    // console.log(this.props)
    return (
      <label className='toggle-btn'>
        <input className='toggle-btn__input'
          type='checkbox' name={this.props.name} onChange={this.handleChange}
          checked={this.props.checked} disabled={disabled} />
        {this.props.label}
        <label
          className='toggle-btn__input-label'
          htmlFor={this.props.name}
          onClick={(event) => { this.handleChange(event) }}>Toggle</label>
      </label>
    )
  }
}

const renderToggleButtonField = (props) => (
  <ToggleButtonField
    {...props.input}
    label={props.label}
    defaultChecked={props.defaultChecked}
    disabled={props.disabled}
    checked={props.input.value}
    onChange={props.input.onChange}
    _key={props._key}
    saveChange={props.saveChange}
  // value={props.toggle}
  />
);

renderToggleButtonField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool
};

export default renderToggleButtonField


// WEBPACK FOOTER //
// ./src/components/form/ToggleButton.js